<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'primary',
    },
    hasIcon: {
      type: Boolean,
      default: false,
    },
    errorMessages: {
      type: [String, Array],
      default: '',
    },
    useSeconds: { type: Boolean, default: true },
  },

  data() {
    return {
      menu: false,
    }
  },

  computed: {
    time: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>

<template>
  <VMenu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="slide-y-transition"
    min-width="325px"
    lazy
    offset-y
    full-width
  >
    <VTextField
      slot="activator"
      v-model="time"
      :label="label"
      :color="color"
      :prepend-icon="hasIcon ? 'access_time' : ''"
      :error-messages="errorMessages"
      readonly
    />

    <VTimePicker
      v-model="time"
      format="24hr"
      full-width
      :use-seconds="useSeconds"
      :color="color"
    >
      <VSpacer />
      <VBtn flat dark :color="color" @click="$refs.menu.save(time)">OK</VBtn>
    </VTimePicker>
  </VMenu>
</template>
